import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.find";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import Draggable from 'vuedraggable';
var questionTypes = [{
  label: 'Text Input',
  value: 0,
  options: false
}, {
  label: 'Single Select',
  value: 1,
  options: true
}, {
  label: 'Multiple Select',
  value: 2,
  options: true
}, {
  label: 'Checkbox',
  value: 3,
  options: true
}, {
  label: 'Radiobutton',
  value: 4,
  options: true
}];
export default {
  props: ['data', 'sort'],
  components: {
    'v-select': vSelect,
    'draggable': Draggable
  },
  data: function data() {
    return {
      questionTypes: questionTypes,
      mode: 'edit',
      // edit,
      showDetail: false,
      title: '',
      question: '',
      answers: null,
      answerType: questionTypes[0]
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.title = this.data.title;
    this.question = this.data.question;
    this.answers = this.data.answers;
    this.answerType = questionTypes.find(function (x) {
      return x.value === _this.data.answerType;
    });
  },
  methods: {
    changeMode: function changeMode(mode) {
      this.mode = mode;
      this.showDetail = true;
    },
    deleteAnswer: function deleteAnswer(value) {
      this.answers = this.answers.filter(function (x) {
        return x.value !== value;
      });
    },
    addAnswer: function addAnswer() {
      this.answers.push({
        value: this.answers.length + 1,
        label: ''
      });
    }
  },
  watch: {
    showDetail: function showDetail(val) {
      if (!val) {}
    }
  }
};